import ApplePay from './ApplePay';
import GooglePay from './GooglePay';
import CreditCard from './CreditCard';
import EasyPayDirect from './EasyPayDirect';
import PayPal from './PayPal';
import StoredPaymentMethods from './StoredPaymentMethods';

export { ApplePay, GooglePay, CreditCard, EasyPayDirect, PayPal, StoredPaymentMethods };
